// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"e1015fb5","299":"ab2a9c31","460":"7e467b02","473":"0e9fcc75","569":"2336ef07","581":"0bbd7ab0","725":"1a243809","866":"152e6633"}[chunkId] + ".chunk.js";
};